import { create } from 'zustand';

type Popup = 'bridge' | 'monitoring' | 'notifications' | false;
interface Store {
  popup?: Popup;
  setPopup: (popup: Popup) => void;
  hidePopup: () => void;
}

export const usePopupStore = create<Store>()((set) => ({
  popup: false,
  setPopup: (popup) => set({ popup }),
  hidePopup: () => set({ popup: false })
}));
